import * as React from "react";
import TicketEventsTableContainer from "../../TicketEvents/TicketEventsTableContainer";

export default class TicketEventsReviewQueue extends React.Component<any> {
  componentDidMount() {
    this.props.setHeader({
      title: "Events > Review Queue",
      description:
        "Review events that are pending approval or have requested changes",
    });
  }

  render() {
    return (
      <TicketEventsTableContainer
        name="events.review_queue"
        mode="review_queue"
        emptyStateMessage="No pending event requests found"
      />
    );
  }
}
